import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchContractsStats, type ContractsStats } from '../apis/fetchContractsStats';
import type { ApiResponse } from '../../../types/apiResponse';
import withPrefix from '../../../helpers/useQueryPrefix';

export const useFetchContractsStats = (): UseQueryResult<ContractsStats, Error> => {
    return useQuery<ApiResponse<ContractsStats>, Error, ContractsStats>({
        queryKey: withPrefix(['contractsStats']),
        queryFn: fetchContractsStats,
        select: (response) => {
            if (response.status !== 200) {
                throw new Error(response.message);
            }
            return response.data as ContractsStats;
        },
    });
};
